<ng-container #containerRef />
